
/**
 * Decodes a GS1 barcode string into an object
 * @param gs1String The GS1 barcode string
 * @returns An object containing the decoded data
 */

// 0101234567891019102563211724062221123456723040028499SBA100000052

type SegmentType = { [key: string]: number };
type ResultType = {
    GTIN: string,
    batchNumber?: string,
    expiryDate?: string,
    serialNumber?: string,
    internalUse?: string
};

type SegmentRule = {
   [key: string]: {
         minLength: number,
         maxLength: number,
         numeric: boolean
   }
};

export function decodeGS1(gs1String: string) {
    let result = {} as ResultType;

    // Mappatura delle lunghezze dei segmenti
    const segmentLengths: SegmentType = {
        '01': 14,  // GTIN
        '10': 20,  // Batch Number
        '17': 6,   // Expiry Date
        '21': 20,  // Serial Number
        '99': 30   // Internal Use
    }

    // Helper function to extract segments
    function extractSegment(data: string, ai: string): string | null {
        const length = segmentLengths[ai];
        if (length === undefined) return null; // Se il segmento non è definito, ritorna null
        const index = data.indexOf(ai);
        if (index === -1) return null; // Se non esiste, ritorna null
        return data.substring(index + ai.length, index + ai.length + length);
    }

    // Extract GTIN (01)
    result.GTIN = extractSegment(gs1String, '01') || '';

    // Extract Batch Number (10) - Optional
    if (segmentLengths['10']) {
        let batchIndex = gs1String.indexOf('10', gs1String.indexOf('01') + segmentLengths['01']);
        if (batchIndex !== -1) {
            let batchEnd = gs1String.indexOf('17', batchIndex);
            if (batchEnd === -1) batchEnd = gs1String.length;
            result.batchNumber = gs1String.substring(batchIndex + 2, batchEnd);
        }
    }

    // Extract Expiry Date (17) - Optional
    if (segmentLengths['17']) {
        let expiryDate = extractSegment(gs1String, '17');
        if (expiryDate) result.expiryDate = expiryDate;
    }

    // Extract Serial Number (21) - Optional
    if (segmentLengths['21']) {
        let serialIndex = gs1String.indexOf('21', gs1String.indexOf('17') + (segmentLengths['17'] || 0));
        if (serialIndex !== -1) {
            let serialEnd = gs1String.indexOf('99', serialIndex); // Check for 99
            if (serialEnd === -1) serialEnd = gs1String.length;
            result.serialNumber = gs1String.substring(serialIndex + 2, serialEnd);
        }
    }

    // Extract Internal Use (99) - Optional
    if (segmentLengths['99']) {
        let internalUse = extractSegment(gs1String, '99');
        if (internalUse) result.internalUse = internalUse;
    }

    return result;
}



export function validateGS1(gs1String: string): boolean {
   const decoded = decodeGS1(gs1String);
   if(!decoded.GTIN ||  !decoded.batchNumber || !decoded.expiryDate) return false;
   return true;
}